import { postData } from '../../Survey/helpers/fetch_services';

function normalizeColor(color, fallback) {
  return color && color !== 'undefined' ? color : fallback;
}

export function mapBrandDetailToTheme(data) {
  return {
    primaryColor: normalizeColor(data?.primaryColor, '#36473F'),
    secondaryColor: normalizeColor(data?.secondaryColor, '#8FA280'),
    backgroundColor: normalizeColor(data?.backgroundColor, '#36473F'),
    highlightColor: normalizeColor(data?.highightColor, '#8FA280'),
    fontColor: normalizeColor(data?.fontColor, '#3a3a3a'),
    logo: data?.logo || null,
    backgroundImg: data?.backgroundImg || null,
  };
}

/** Loads company brand via the same API used by survey and Client Connect. */
export async function fetchLearningBrandDetails({ companyId, surveyId } = {}) {
  const body = {};

  if (companyId) {
    body.company_id = companyId;
  } else if (surveyId) {
    body.survey_id = surveyId;
  } else {
    return null;
  }

  const result = await postData('api/getBrandDetail', body);

  if (result?.status !== 200 || !result?.data) {
    return null;
  }

  return mapBrandDetailToTheme(result.data);
}
